import React, { useState, useEffect } from 'react';
import { 
  Home, Flame, Lightbulb, Star, TrendingUp, Radio, Compass, 
  Cpu, Mic, Film, Trophy, Gamepad2, X, Newspaper, Laugh, 
  Globe, HeartHandshake, Church, Landmark, Megaphone, FolderOpen,
  Award, Zap, Tv, Palette, Smile, Clapperboard, Tv2, BookOpen, UserCheck, Layers 
} from 'lucide-react';
// ⚠️ Ajuste o caminho do supabaseClient conforme a sua estrutura de pastas
import { supabase } from '../../../../../supabaseClient';

interface SidebarProps {
  activeCategory: string;
  onSelectCategory: (category: string) => void;
  isOpenMobile: boolean;
  onCloseMobile: () => void;
}

export default function PlayFeedSidebar({ activeCategory, onSelectCategory, isOpenMobile, onCloseMobile }: SidebarProps) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ORDEM ORIGINAL INTACTA
  const categories = [
    { name: 'Tudo', label: 'Início', icon: <Home size={18} />, color: '#E50914' },
    { name: 'curiosidades', label: 'Curiosidades', icon: <Lightbulb size={18} />, color: '#ffd700' },
    { name: 'novidades', label: 'Novidades', icon: <TrendingUp size={18} />, color: '#00d2ff' },
    { name: 'podcast', label: 'Podcast', icon: <Mic size={18} />, color: '#ff007f' },
    { name: 'Em Alta', label: 'Hype', icon: <Flame size={18} />, color: '#ff4500' },
    
    // 👇 Mudamos para 'filme' para abranger todos os filmes trazidos pelo robô
    
    
    { name: 'Notícias', label: 'Notícias', icon: <Newspaper size={18} />, color: '#ff3b30' },
    { name: 'Vídeos Engraçados', label: 'Vídeos Engraçados', icon: <Laugh size={18} />, color: '#ffcc00' },
  ];

  // Mostra as 11 primeiras por padrão, ou todas se clicar em ver mais (como estava antes)
  const displayedCategories = showAll ? categories : categories.slice(0, 11);

  if (isMobile && !isOpenMobile) return null;

  return (
    <div className="sidebar-scrollbar" style={{
      width: isMobile ? '280px' : '260px',
      minWidth: isMobile ? '280px' : '260px',
      maxWidth: isMobile ? '280px' : '260px',
      height: 'calc(100vh - 80px)', 
      position: isMobile ? 'fixed' : 'sticky',
      top: '80px',
      left: 0,
      flexShrink: 0,
      backgroundColor: '#050505',
      borderRight: '1px solid rgba(255,255,255,0.08)',
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 12px 40px 12px',
      gap: '6px',
      overflowY: 'auto', 
      zIndex: 100,
      boxShadow: isMobile ? '10px 0 30px rgba(0,0,0,0.9)' : 'none',
      transition: 'transform 0.3s ease',
      boxSizing: 'border-box'
    }}>
      
      <style>
        {`
          .sidebar-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .sidebar-scrollbar::-webkit-scrollbar-track {
            background: #050505;
          }
          .sidebar-scrollbar::-webkit-scrollbar-thumb {
            background: #222;
            border-radius: 10px;
          }
          .sidebar-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #E50914;
          }
        `}
      </style>

      {/* CABEÇALHO COM O BOTÃO DE ALTERNAR NO TOPO */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '8px', padding: '0 4px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ color: '#777', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', margin: 0 }}>
            Categorias
          </h3>
          {isMobile && (
            <button 
              onClick={onCloseMobile}
              style={{ background: 'transparent', border: 'none', color: '#aaa', cursor: 'pointer', padding: '4px' }}
            >
              <X size={20} />
            </button>
          )}
        </div>

        {/* Botão de Alternância Rápida */}
        <button
          onClick={() => setShowAll(!showAll)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 12px',
            borderRadius: '8px',
            border: showAll ? '1px solid #E50914' : '1px solid rgba(255, 255, 255, 0.12)',
            backgroundColor: showAll ? 'rgba(229, 9, 20, 0.15)' : 'rgba(255, 255, 255, 0.04)',
            color: showAll ? '#fff' : '#ccc',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '600',
            width: '100%',
            transition: 'all 0.2s ease'
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Layers size={14} color={showAll ? '#E50914' : '#888'} />
            {showAll ? 'Mostrando Todas' : 'Principais'}
          </span>
          <span style={{ fontSize: '11px', color: showAll ? '#ff4d4d' : '#888', textDecoration: 'underline' }}>
            {showAll ? 'Versão' : 'Beta'}
          </span>
        </button>
      </div>

      {displayedCategories.map((cat) => {
        const isActive = activeCategory === cat.name;
        
        return (
          <button
            key={cat.name}
            onClick={() => {
              onSelectCategory(cat.name);
              if (isMobile) onCloseMobile();
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '11px 14px',
              borderRadius: '10px',
              border: isActive ? `1px solid ${cat.color}` : '1px solid rgba(255, 255, 255, 0.08)',
              backgroundColor: isActive ? `${cat.color}20` : 'rgba(255, 255, 255, 0.02)',
              color: isActive ? '#fff' : '#aaa',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              width: '100%',
              textAlign: 'left',
              boxShadow: isActive ? `0 0 15px ${cat.color}40` : 'none',
            }}
          >
            <span style={{ color: isActive ? cat.color : '#888', display: 'flex', alignItems: 'center' }}>
              {cat.icon}
            </span>
            <span style={{ fontSize: '14px', fontWeight: isActive ? '600' : '400' }}>
              {cat.label}
            </span>
          </button>
        );
      })}

    </div>
  );
}